// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030604/js/" + chunkId + "." + {"44":"4fe84ad8","225":"519e4102","481":"340a9fc8","486":"31d0cc82","770":"bf43840c"}[chunkId] + ".0.8553218018689287.chunk.js";
};